import { Logger, EventEmitter } from 'vue-infra';
/**
 * Basic Logic Component.
 */
class BaseClass extends EventEmitter {
  get logger() {
    return Logger.getLogger(`${this.$name}`);
  }
  constructor(config) {
    super();
    this.$name = `${config.type}<${config.name}>` || `${config.type}<Generic>`;
    this.logger.debug('Component Created', '*Component', this);
  }

  throwError({ graphName, message }) {
    if (graphName) {
      this.logger.graph(`${this.$name}_${graphName}`);
    }
    if (message) {
      this.logError(message);
      throw new Error(message);
    }
  }

  logError(message) {
    this.logger.error(message);
  }
}

export default BaseClass;
